import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Template from 'shared/src/template'
import Badge from '@material-ui/core/Badge'

import FieldSummary from '../widgets/FieldSummary'

const useStyles = makeStyles(theme => ({
  
}))

const SlotSummary = ({
  admin = false,
  slot,
  options,
  booking,
  formConfig,
  extraRows = [],
}) => {
  const classes = useStyles()
  if(!slot) return null
  const template = Template({
    slot,
    config: formConfig,
    options,
    reference: booking ? booking.reference : '',
    createdAt: booking ? booking.created_at : new Date(),
  })
  const slotFields = slot.templates.summaryFields
    .filter(field => {
      if(typeof(field.admin) !== 'boolean') return true
      return field.admin === admin
    })
    .map(field => {
      const isOverridden = (field.overrides || []).find(overrideName => {
        return typeof(slot._overriddenValues[overrideName]) !== 'undefined'
      })
      return {
        title: field.title,
        value: (
          <div>
            {
              admin && isOverridden && (
                <span>
                  <Badge
                    color="secondary"
                    variant="dot"
                  />
                  &nbsp;
                  &nbsp;
                </span>
              )
            }
            { template(field.value, `slot.templates.summaryFields.${field.title}`) }
          </div>
        )
      }
    })
  const summaryData = slotFields.concat(extraRows)

  return (
    <FieldSummary
      data={ summaryData }
    />
  )
}

export default SlotSummary